import { chunk } from "lodash"
import { AnimatePresence } from "motion/react"

import { type DataForDisplay, type Uuid } from "#customTypes/globalTypes"

import AnimateInFlex, { ANIMATION_BY_KEY } from "./AnimateInFlex"
import Flex from "./Flex"
import LinkButton from "./LinkButton"
import TextOverrun from "./TextOverrun"

interface ClickableNameListProps {
  namesForDisplay: DataForDisplay[]
  onClick: (id: Uuid) => void
  columns?: 1 | 2 | 3
}

const COLUMN_WIDTHS_BY_COLUMN_COUNT = {
  1: 160,
  2: 110,
  3: 100,
  4: 100,
  5: 100,
}

const DEFAULT_ROW_COUNT = 7

const ClickableNameList = ({
  namesForDisplay,
  onClick,
  columns = 2,
}: ClickableNameListProps) => {
  const columnSize = Math.ceil(
    namesForDisplay.length > DEFAULT_ROW_COUNT * columns
      ? namesForDisplay.length / columns
      : DEFAULT_ROW_COUNT
  )
  const dataByColumns = chunk(namesForDisplay, columnSize)
  const columnCount = dataByColumns.length as 1 | 2 | 3 | 4 | 5

  return (
    <Flex
      style={{
        maxWidth: "100%",
        gap: 16,
        maxHeight: 220,
        overflowY: "auto",
        paddingRight: 12,
      }}
    >
      {namesForDisplay?.length ? (
        dataByColumns.map((column, columnIndex) => (
          <Flex
            col
            key={columnIndex}
            style={{
              flex: 1,
              minWidth: COLUMN_WIDTHS_BY_COLUMN_COUNT[columnCount],
              width: `${Math.floor(100 / columnCount)}%`,
            }}
            gap={2}
          >
            <AnimatePresence mode="popLayout">
              {column.map(({ id, label }) => (
                <AnimateInFlex
                  key={`clickable-name-list-${id}`}
                  animation={ANIMATION_BY_KEY.leftSm}
                  style={{
                    width: "fit-content",
                    maxWidth: "100%",
                  }}
                >
                  <LinkButton
                    onClick={() => onClick(id)}
                    style={{
                      display: "flex",
                      minWidth: 0,
                      padding: "2px 8px 2px 0px",
                      flexGrow: 1,
                      justifyContent: "flex-start",
                    }}
                  >
                    <TextOverrun text={label} />
                  </LinkButton>
                </AnimateInFlex>
              ))}
            </AnimatePresence>
          </Flex>
        ))
      ) : (
        <AnimateInFlex animation={ANIMATION_BY_KEY.leftSm}>None</AnimateInFlex>
      )}
    </Flex>
  )
}

export default ClickableNameList
